export const prevArrowIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M15.8437 20C16.0718 18.2222 13.38 13.0667 9 12C13.38 10.9333 16.0718 5.77778 15.8437 4" stroke="black" stroke-width="0.75" stroke-miterlimit="5.75877" stroke-linejoin="bevel"/>
  </svg>
  `
export const nextArrowIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.1563 4C8.92817 5.77778 11.62 10.9333 16 12C11.62 13.0667 8.92817 18.2222 9.1563 20" stroke="black" stroke-width="0.75" stroke-miterlimit="5.75877" stroke-linejoin="bevel"/>
  </svg>
  `
